import moment from 'moment';
import { DATE_FORMAT } from 'constants/AppConstants';

const formatDate = (date, format = 'timestamp') => {
  return date && moment(date).format(DATE_FORMAT[format]);
};

export default formatDate;
